import styled, { css } from 'styled-components';
import {
  AnchoredAlert,
  Divider,
  Flex,
  Link,
  styleMixinFocusOutline,
} from '@amzn/storm-ui';

export const AllToolsSideNavLinkWrapper = styled.div`
  padding: '20px 40px', // TODO: replace with theme spacing tokens
  borderRadius: '8px', // TODO: replace with theme border radius token
  min-height: 40px;
  width: 296px;
  cursor: pointer;
`;

const sideNavLinkStyles = css<{ isSelected: boolean }>`
  box-sizing: border-box;
  gap: 10px;
  width: 100%;
  display: flex;
  align-items: center;
  color: ${({ theme }) => theme.text.color.default};
  text-decoration: none;
  border-radius: ${({ theme }) => theme.border.radius.large};
  cursor: pointer;
  border: none;
  background-color: ${({ theme }) =>
    theme.selectableContainer.backgroundColor.default};
  min-height: 40px;
  :hover,
  :focus-visible {
    background-color: ${({ theme }) =>
      theme.selectableContainer.backgroundColor.hover};
  }
`;

export const AllToolsNavWrapper = styled.div`
  display: flex; // TODO: replace with the Flex component from StormUI
  justify-content: space-between;
  width: 100%;
`;

export const AllToolsSideNavLinkInnerWrapper = styled(Link)<{
  isSelected: boolean;
}>`
  border-radius: ${({ theme }) => theme.border.radius.large};
  ${sideNavLinkStyles};
  padding: 0 ${({ theme }) => theme.spacing.xxsmall.default};
  &:link,
  &:visited {
    color: ${({ theme }) => theme.text.color.default};
    text-decoration: none;
  }

  &:hover,
  &:active,
  &:focus-visible {
    text-decoration: none;
    color: ${({ theme }) =>
      theme.color
        .gray[800]}; // TODO: replace with the theme token so that this nav link looks fine in dark mode
    background-color: ${({ theme }) =>
      theme.selectableContainer.backgroundColor.hover};
  }
  &:focus-visible {
    ${styleMixinFocusOutline};
  }
  ${({ isSelected, theme }) =>
    isSelected &&
    css`
      background-color: ${theme.selectableContainer.backgroundColor.hover};
      font-weight: 700;
    `};
`;

export const AccordionContentInnerWrapper = styled.div`
  display: flex; // TODO: Replace with the Flex component from StormUI
  flex-direction: column;
  margin-block-start: ${({ theme }) => theme.spacing.xsmall.default};
  margin-inline-start: 19px; // Matches the sidenav accordion to align vertical bar with an icon above
  padding-inline-start: ${({ theme }) => theme.spacing.base.default};
  border-inline-start: 2px solid
    ${({ theme }) => theme.border.color.subtle.default};
`;

export const AccordionContentGroupWrapper = styled(Flex)`
  box-sizing: border-box;
`;

export const AccordionContentSubTitle = styled.span`
  // TODO: replace with Text component from StormUI
  // It is important to use StormUI components where possible since dark theme support is provided out of box

  color: ${({ theme }) => theme.text.color.default};

  &&& {
    font-size: 12px;
  }

  font-weight: bold;
  line-height: 1.333;
  padding: ${({ theme }) =>
    `${theme.spacing.xxsmall.default} 0 ${theme.spacing.xxxsmall.default} ${theme.spacing.xxsmall.default}`};
  margin-block-end: ${({ theme }) => theme.spacing.xxsmall.default};
`;

export const StyledDivider = styled(Divider)`
  margin: 15px 12px 15px 0px; // TODO: replace with the theme spacing tokens
  width: 90%;
`;

export const AccordionLinkWrapper = styled.div<{
  isSelected: boolean;
}>`
  box-sizing: border-box;
  width: 100%;
  display: flex; // TODO: replace with the Flex component from StormUI
  align-items: center;
  justify-content: space-between;
  color: ${({ theme }) => theme.text.color.default};
  text-decoration: none;
  border-radius: ${({ theme }) => theme.border.radius.large};
  cursor: pointer;
  border: none;
  background-color: ${({ theme }) =>
    theme.selectableContainer.backgroundColor.default};
  min-height: 40px;
  padding-inline: ${({ theme }) =>
    `${theme.spacing.xxsmall.default} ${theme.spacing.xsmall.default}`};
      :hover,
      :focus-visible {
        background-color: ${({ theme }) =>
          theme.selectableContainer.backgroundColor.hover};

  ${({ isSelected, theme }) =>
    isSelected &&
    css`
      background-color: ${theme.selectableContainer.backgroundColor.selected};
    `};
`;

export const AllToolsTitleWrapper = styled(Flex).attrs({
  alignItems: 'center',
  paddingInlineStart: 'xxsmall',
})`
  min-height: 40px;
`;

export const AllToolsAnchoredAlert = styled(AnchoredAlert)`
  // TODO: add more specificity instead of using !important
  z-index: 399 !important;
`;
